import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Star } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-heading">Perth Lawn Coring</h3>
            <p className="body-small">
              Professional lawn coring and verti-mowing services for Perth's Northern Suburbs.
            </p>
            <div className="footer-rating">
              <Star size={16} fill="#D3FF62" color="#D3FF62" />
              <Star size={16} fill="#D3FF62" color="#D3FF62" />
              <Star size={16} fill="#D3FF62" color="#D3FF62" />
              <Star size={16} fill="#D3FF62" color="#D3FF62" />
              <Star size={16} fill="#D3FF62" color="#D3FF62" />
              <span className="body-small">5.0 (14 Google Reviews)</span>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-subheading">Quick Links</h4>
            <nav className="footer-nav">
              <Link to="/" className="footer-link">Home</Link>
              <Link to="/services" className="footer-link">Services</Link>
              <Link to="/service-areas" className="footer-link">Service Areas</Link>
              <Link to="/reviews" className="footer-link">Reviews</Link>
              <Link to="/contact" className="footer-link">Contact</Link>
            </nav>
          </div>

          <div className="footer-section">
            <h4 className="footer-subheading">Contact Us</h4>
            <div className="footer-contact">
              <a href="tel:0417910217" className="footer-contact-item">
                <Phone size={18} />
                <span>0417 910 217</span>
              </a>
              <a href="mailto:info@perthlawncoring.com.au" className="footer-contact-item">
                <Mail size={18} />
                <span>Get a Quote</span>
              </a>
              <div className="footer-contact-item">
                <MapPin size={18} />
                <span>28 Pelican Parade<br />Ballajura WA 6066</span>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-subheading">Hours</h4>
            <p className="body-small">Monday - Friday<br />8:00 AM - 5:00 PM AWST</p>
            <p className="body-small" style={{ marginTop: '8px' }}>Saturday - Sunday<br />By Appointment</p>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="caption">
            © {new Date().getFullYear()} Perth Lawn Coring. All rights reserved.
          </p>
          <p className="caption">
            Servicing Perth's Northern Suburbs | Ballajura-based
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;